import React from "react";

import IDHFormattedMessage from "src/app/components/IDHFormattedMessage/IDHFormattedMessage";

interface MessageDetailItemProps {
  labelId: string;
  labelDefault: string;
  children?: React.ReactNode;
  dangerousHTML?: string;
}

export default function MessageDetailItem({
  labelId,
  labelDefault,
  children,
  dangerousHTML,
}: MessageDetailItemProps) {
  return (
    <li>
      <div className="message-history-preview__label">
        <IDHFormattedMessage id={labelId} defaultMessage={labelDefault} />
      </div>
      {dangerousHTML ? (
        <div
          className="message-history-preview__data"
          // eslint-disable-next-line react/no-danger
          dangerouslySetInnerHTML={{ __html: dangerousHTML }}
        />
      ) : (
        <div className="message-history-preview__data">{children}</div>
      )}
    </li>
  );
}
